import Vue from 'vue';
import Amplify from "aws-amplify";
import awsconfig from "./aws-exports.js";

Amplify.configure(awsconfig);

import {
    applyPolyfills,
    defineCustomElements,
} from "@aws-amplify/ui-components/loader";

applyPolyfills().then(() => {
    defineCustomElements(window);
});

Vue.config.ignoredElements = [/amplify-\w*/];